import gql from 'graphql-tag'

export default gql`
query registrationProfile($isVirtual: Boolean!, $skip: Int!, $limit: Int!){
  registrationProfile(isVirtual:$isVirtual, skip: $skip, limit: $limit){
    _id
    status
    expired
    expireAt
    eventId
    testMode
    createdAt
    event {
      _id
      slug
      isRegOpen
      regClosed
      extraProductCount
      settings {
        _id
        registration {
          _id
          maxOrders
        }
        virtualRun {
          _id
          distanceMode
          noEcer
          period {
            start
            end
          }
        }
        ticket {
          _id
          hideNumber
        }
      }
      name {
        en
        th
        zh
      }
      periods {
        _id
        start
        end
        preRegisterStart
        preRegisterEnd
      }
    }
    orders {
      _id
      code
      status
      expireAt
    }
    successfulPayment {
      _id
      amount
      method
    }
    registrationType {
      _id
      name {
        en
        th
        zh
      }
      lotto {
        enabled
      }
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/registrationProfile.js